var map = {
	"./arbitrum.json": [
		35806,
		5806
	],
	"./avalanche.json": [
		6917,
		6917
	],
	"./base.json": [
		82193,
		2193
	],
	"./ethereum.json": [
		56061,
		6061
	],
	"./linea.json": [
		25757,
		5757
	],
	"./optimism.json": [
		16894,
		6894
	],
	"./polygon.json": [
		61242,
		1242
	],
	"./sonic.json": [
		55012,
		5012
	],
	"./unichain.json": [
		26923,
		6923
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 11349;
module.exports = webpackAsyncContext;